import React from 'react';
const ErrorMessage = ({ children, showIcon = true }) => {
  return (
    <div className="flex gap-1">
      {showIcon && (
        <div className="h-3 float-left flex justify-center items-center mr-1 mt-0.75">
          <img className="min-w-3 min-h-3" src={require('assets/resources/Cancel.svg').default} alt="cancel icon" width={12} height={12} />
        </div>
      )}
      {children}
    </div>
  );
};

export default React.memo(ErrorMessage);
